export { default as Paletizaciones } from "./Paletizaciones";

